module.exports = __webpack_public_path__ + "img/JPY.1099da33.svg";